import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
// import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {

	render() {
		return;
	}

}
